import { render, staticRenderFns } from "./TransferDiscount.vue?vue&type=template&id=4328ef32&scoped=true&"
import script from "./TransferDiscount.vue?vue&type=script&lang=js&"
export * from "./TransferDiscount.vue?vue&type=script&lang=js&"
import style0 from "./TransferDiscount.vue?vue&type=style&index=0&id=4328ef32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4328ef32",
  null
  
)

export default component.exports